import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, l = /* @__PURE__ */ e("path", { d: "M6.6 4.75c-1.167 0-2.05.892-2.05 1.917a.75.75 0 0 1-.75.75c-1.167 0-2.05.892-2.05 1.916 0 .495.206.959.55 1.306L1.24 11.7a3.326 3.326 0 0 1-.99-2.367c0-1.69 1.257-3.05 2.871-3.353.333-1.58 1.79-2.73 3.479-2.73.865 0 1.666.3 2.287.803l-1.071 1.07A2.13 2.13 0 0 0 6.6 4.75Z" }, null, -1), n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "m4.31 12.75-.78.78a.75.75 0 0 1-1.06-1.06l9-9a.75.75 0 1 1 1.06 1.06l-.482.482c.858.488 1.488 1.346 1.606 2.336 1.19.316 2.096 1.361 2.096 2.652 0 1.553-1.31 2.75-2.85 2.75H4.31Zm6.604-6.603c.802.225 1.355 1.008 1.244 1.742a.75.75 0 0 0 .742.861c.78 0 1.35.594 1.35 1.25s-.57 1.25-1.35 1.25H5.81l5.104-5.103Z",
  "clip-rule": "evenodd"
}, null, -1), d = [
  l,
  n
];
function r(s, a) {
  return t(), o("svg", c, [...d]);
}
const i = { render: r };
export {
  i as default,
  r as render
};
